import { useUserStore } from '~/stores/user'
import { IUserType } from '~/types/UserData'

export default defineNuxtRouteMiddleware(to => {
  const userStore = useUserStore()
  const userRoleAuth0 = userStore.getUserRole?.id
  const userRoleFirebase = (userStore.getUser?.userAccess as string) || 'user'
  // Allow access if user is admin in Auth0 OR Firebase
  const isAuth0Admin = userRoleAuth0 === IUserType.ADMIN
  const isFirebaseAdmin = ['admin'].includes(userRoleFirebase)
  if (!(isAuth0Admin || isFirebaseAdmin)) {
    // Redirect non-admin users to home page
    return navigateTo('/')
  }
})
